import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";
import React, { memo } from "react";
export let reasonRejection = [
  "Culture Fit",
  "Insufficient Experience",
  "Skills lagging",
  "Other",
];
const GroupRadioButton = ({ value, setValue }) => {
  const handleChange = (event) => {
    setValue(event.target.value);
  };

  return (
    <>
      <FormControl>
        <FormLabel
          id="reject-status-group"
          sx={{
            fontWeight: "bold",
            fontSize: "14px",
            color: "rgba(0, 0, 0, 0.87)",
          }}
        >
          Reason For Rejection
        </FormLabel>
        <RadioGroup
          aria-labelledby="reject-status-group"
          name="controlled-radio-buttons-group"
          value={value}
          onChange={handleChange}
          row
        >
          {reasonRejection?.map((reason, idx) => (
            <FormControlLabel
              key={idx}
              value={reason}
              control={<Radio />}
              label={
                <Typography
                  sx={{
                    fontFamily: "Urbane-Light",
                    fontWeight: "bold",
                    fontSize: "12px",
                    textTransform: "capitalize",
                  }}
                >
                  {reason}
                </Typography>
              }
            />
          ))}
        </RadioGroup>
      </FormControl>
    </>
  );
};

export default memo(GroupRadioButton);
